/** Query parameter carrying the token on a stamped attachment URL. */
export const CONTENT_TOKEN_QUERY_PARAM = "t";
